/** Icono de color por categoría para distinguir productos en el listado. */
export function categoriaIcon(cat: string | undefined | null): { emoji: string; bg: string } {
  const n = (cat || '').toLowerCase();
  if (/joy|anill|arete|collar/.test(n)) return { emoji: '💍', bg: '#EDE9FE' };
  if (/marroq|cuero|bolso|cartera/.test(n)) return { emoji: '👜', bg: '#FEF3C7' };
  if (/ropa|textil|prenda|camisa|vestid/.test(n)) return { emoji: '👕', bg: '#DBEAFE' };
  if (/hogar|casa|vela|jab[oó]n/.test(n)) return { emoji: '🏠', bg: '#D1FAE5' };
  if (/servic|ajuste|grabado/.test(n)) return { emoji: '🛠', bg: '#EDE9FE' };
  return { emoji: '📦', bg: '#F1F5F9' };
}
